var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent is-vertical" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _vm._m(0),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("Purchase Order No."),
              ]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  staticClass: "input is-static",
                  attrs: { type: "text", readonly: "" },
                  domProps: {
                    value: `${_vm.innerValue.prefix}${_vm.innerValue.purchaseOrderNo}${_vm.innerValue.suffix}`,
                  },
                }),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "field is-narrow" },
              [
                _c("label", { staticClass: "label" }, [_vm._v("Date")]),
                !_vm.readOnlyView && !_vm.isReceive
                  ? _c("v-date-picker", {
                      attrs: {
                        "is-dark": _vm.$theme.isDark,
                        masks: _vm.formats,
                        attributes: _vm.attrs,
                        locale: _vm.$userInfo.locale,
                        timezone: _vm.$filters.getIanaTimezone(),
                      },
                      on: {
                        input: function ($event) {
                          _vm.selectedPoDate =
                            _vm.$filters.fromISOWithCurrentTime(
                              $event.toISOString()
                            )
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ inputValue, inputEvents }) {
                              return [
                                _c("div", { staticClass: "field" }, [
                                  _c(
                                    "div",
                                    { staticClass: "control has-icons-left" },
                                    [
                                      _c(
                                        "input",
                                        _vm._g(
                                          {
                                            staticClass: "input",
                                            attrs: {
                                              type: "text",
                                              placeholder: "Quote Date",
                                              readonly: "",
                                            },
                                            domProps: { value: inputValue },
                                          },
                                          inputEvents
                                        )
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon is-small is-left",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-calendar mdi-18px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1443898968
                      ),
                      model: {
                        value: _vm.selectedPoDate,
                        callback: function ($$v) {
                          _vm.selectedPoDate = $$v
                        },
                        expression: "selectedPoDate",
                      },
                    })
                  : _c("span", [
                      _c("input", {
                        staticClass: "input is-static",
                        attrs: { readonly: "" },
                        domProps: {
                          value: _vm.$filters.formatDateTimezone(
                            _vm.purchaseOrderDate,
                            _vm.$userInfo.locale
                          ),
                        },
                      }),
                    ]),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Vendors")]),
          _vm.readOnlyView || _vm.isReceive
            ? _c("div", { staticClass: "field-body" }, [
                _c("input", {
                  staticClass: "input is-static",
                  attrs: { readonly: "" },
                  domProps: {
                    value: _vm.selectedVendor ? _vm.selectedVendor.name : "",
                  },
                }),
              ])
            : _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field has-addons" }, [
                  _c(
                    "div",
                    { staticClass: "control is-expanded" },
                    [
                      _vm.vendors
                        ? _c(
                            "multiselect",
                            {
                              class: {
                                "is-danger": _vm.$v.entity.vendorId.$error,
                              },
                              attrs: {
                                "deselect-label": "Can't remove this value",
                                "track-by": "name",
                                label: "name",
                                "show-labels": false,
                                options: _vm.vendors,
                                "options-limit": _vm.assetFilter.pageSize,
                                loading: _vm.isVendorLoading,
                                "internal-search": false,
                                searchable: true,
                                "allow-empty": true,
                                placeholder: "Select a vendor",
                              },
                              on: {
                                select: _vm.selectVendor,
                                remove: _vm.removeVendor,
                                "search-change": _vm.getVendorDropdownFilter,
                              },
                              model: {
                                value: _vm.selectedVendor,
                                callback: function ($$v) {
                                  _vm.selectedVendor = $$v
                                },
                                expression: "selectedVendor",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "has-text-danger",
                                  attrs: { slot: "noResult" },
                                  slot: "noResult",
                                },
                                [_vm._v("Vendor not found.")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.$v.entity && !_vm.$v.entity.vendorId.validGuid
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v("Vendor is required. "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button",
                        class: _vm.vendorButtonClass,
                        on: {
                          click: function ($event) {
                            return _vm.onEditAddVendor()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon" }, [
                          _c("i", {
                            staticClass: "mdi mdi-24px",
                            class: _vm.vendorButtonIconClass,
                          }),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Contact")]),
          _vm.readOnlyView || _vm.isReceive
            ? _c("div", { staticClass: "field-body" }, [
                _c("input", {
                  staticClass: "input is-static",
                  attrs: { readonly: "" },
                  domProps: {
                    value: _vm.selectedContact
                      ? _vm.selectedContact.fullname
                      : "",
                  },
                }),
              ])
            : _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field has-addons" }, [
                  _c(
                    "div",
                    { staticClass: "control is-expanded" },
                    [
                      _vm.contacts
                        ? _c(
                            "multiselect",
                            {
                              attrs: {
                                "deselect-label": "Can't remove this value",
                                "track-by": "contactId",
                                label: "fullname",
                                "show-labels": false,
                                options: _vm.contacts,
                                "options-limit": _vm.assetFilter.pageSize,
                                "internal-search": false,
                                searchable: true,
                                "allow-empty": true,
                                placeholder: "select a contact",
                              },
                              on: {
                                select: _vm.selectContact,
                                remove: _vm.removeContact,
                                "search-change": _vm.onContactSearchChange,
                              },
                              nativeOn: {
                                input: function ($event) {
                                  return _vm.captureContactInput.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.selectedContact,
                                callback: function ($$v) {
                                  _vm.selectedContact = $$v
                                },
                                expression: "selectedContact",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "has-text-danger",
                                  attrs: { slot: "noResult" },
                                  slot: "noResult",
                                },
                                [_vm._v("Contact not found.")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button",
                        class: _vm.contactButtonClass,
                        attrs: {
                          disabled: !_vm.hasVendorSelected || _vm.readOnlyView,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onEditAddContact()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon" }, [
                          _c("i", {
                            staticClass: "mdi mdi-24px",
                            class: _vm.contactButtonIconClass,
                          }),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Phone")]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.phone,
                      expression: "phone",
                    },
                  ],
                  staticClass: "input is-static",
                  attrs: { type: "text", placeholder: "", readonly: "" },
                  domProps: { value: _vm.phone },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.phone = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Fax")]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.fax,
                      expression: "fax",
                    },
                  ],
                  staticClass: "input is-static",
                  attrs: { type: "text", placeholder: "", readonly: "" },
                  domProps: { value: _vm.fax },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.fax = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("ABN")]),
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.abn,
                      expression: "abn",
                    },
                  ],
                  staticClass: "input is-static",
                  attrs: { type: "text", placeholder: "", readonly: "" },
                  domProps: { value: _vm.abn },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.abn = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field is-narrow quote-width" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Quote")]),
              _vm.innerValue.isNew ||
              !_vm.isQuoteLinked ||
              _vm.itemSummaries.length === 0
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.quoteNo,
                        expression: "quoteNo",
                      },
                    ],
                    staticClass: "input is-uppercase",
                    class: { "is-danger": _vm.$v.entity.quoteId.$error },
                    attrs: { placeholder: "Start typing to search..." },
                    domProps: { value: _vm.quoteNo },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.quoteNo = $event.target.value
                        },
                        _vm.searchQuote,
                      ],
                    },
                  })
                : _c("span", [_vm._v(_vm._s(_vm.innerValue.quoteNo))]),
              _vm.$v.entity &&
              _vm.$v.entity.quoteId.isValidQuoteNo &&
              _vm.quoteNo !== ""
                ? _c("span", { staticClass: "help is-success" }, [
                    _vm._v("Valid Quote No."),
                  ])
                : _vm.quoteNo.length > 0
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v("Invalid Quote No."),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Order by")]),
              !_vm.readOnlyView && !_vm.isReceive
                ? _c(
                    "div",
                    { staticClass: "control is-expanded" },
                    [
                      _c("bulma-autocomplete", {
                        attrs: {
                          placeholder: "Orderer",
                          data: _vm.filteredOrderers,
                          "keep-first": true,
                          loading: false,
                          "class-prop": _vm.$v.entity.orderer.$error
                            ? "is-danger"
                            : "",
                        },
                        on: { input: _vm.handleRecieverChange },
                        model: {
                          value: _vm.innerValue.orderer,
                          callback: function ($$v) {
                            _vm.$set(_vm.innerValue, "orderer", $$v)
                          },
                          expression: "innerValue.orderer",
                        },
                      }),
                      !_vm.$v.entity.orderer.required
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v(" Order By is required. "),
                          ])
                        : !_vm.$v.entity.orderer.lettersOnly
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v(" Order By must contain only letters. "),
                          ])
                        : !_vm.$v.entity.orderer.maxLength
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v(
                              " Order By must be less than 200 characters. "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _c("div", [
                    _vm._v(" " + _vm._s(_vm.innerValue.orderer) + " "),
                  ]),
            ]),
            _c("div", { staticClass: "field is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Parts Check No")]),
              _vm.innerValue.partsCheckPurchaseOrderNo
                ? _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { type: "text", placeholder: "", readonly: "" },
                      domProps: {
                        value: `${_vm.innerValue.partsCheckPurchaseOrderNo}`,
                      },
                    }),
                  ])
                : _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input is-static",
                      attrs: { type: "text", placeholder: "", readonly: "" },
                      domProps: { value: "Manual PO" },
                    }),
                  ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isDisplayPrice,
                    expression: "isDisplayPrice",
                  },
                ],
                staticClass: "is-checkradio is-info",
                attrs: { type: "checkbox", id: "price" },
                domProps: {
                  checked: Array.isArray(_vm.isDisplayPrice)
                    ? _vm._i(_vm.isDisplayPrice, null) > -1
                    : _vm.isDisplayPrice,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.isDisplayPrice,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.isDisplayPrice = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.isDisplayPrice = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.isDisplayPrice = $$c
                    }
                  },
                },
              }),
              _c("label", { attrs: { for: "price" } }, [
                _vm._v("Display Prices on Report"),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isDisplayPart,
                    expression: "isDisplayPart",
                  },
                ],
                staticClass: "is-checkradio is-info",
                attrs: { type: "checkbox", id: "part" },
                domProps: {
                  checked: Array.isArray(_vm.isDisplayPart)
                    ? _vm._i(_vm.isDisplayPart, null) > -1
                    : _vm.isDisplayPart,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.isDisplayPart,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.isDisplayPart = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.isDisplayPart = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.isDisplayPart = $$c
                    }
                  },
                },
              }),
              _c("label", { attrs: { for: "part" } }, [
                _vm._v("Display Part No. on Report"),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "is-divider" }),
          _c("label", { staticClass: "label" }, [_vm._v("Recent Remarks")]),
          _c(
            "table",
            {
              staticClass:
                "table is-bordered is-striped is-narrow is-fullwidth",
            },
            [
              _c("thead"),
              _c(
                "tbody",
                _vm._l(_vm.displayRemarks, function (remark) {
                  return _c("tr", { key: remark.remarkId }, [
                    _c("td", { staticClass: "is-content-width" }, [
                      _c("span", { staticClass: "tag is-info" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatDateTimeLocale(
                              remark.remarkDateTime,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                    ]),
                    _c("td", { staticClass: "is-remark" }, [
                      _c("div", [_vm._v(_vm._s(remark.remarks))]),
                    ]),
                  ])
                }),
                0
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "tile is-parent is-half" }, [
      _c(
        "article",
        { staticClass: "tile is-child box" },
        [
          _c("p", { staticClass: "title" }, [_vm._v("Summary")]),
          _c("purchase-order-detail-summary", {
            attrs: { "item-summaries": _vm.itemSummaries },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-gapless" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v(" Details ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }